import { useState, useEffect } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useJobPostCount = () => {
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchJobPostCount = async () => {
      try {
        const response = await axiosInstance.get("jobs/job_posts/total_count/");

        setCount(response.data.total_count);
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchJobPostCount();
  }, []);

  return { count, loading, error };
};
